import React from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, PageHero } from '../../components/shop/ShopBits';
import DoorEnquiryForm from '../../components/shop/DoorEnquiryForm';
import usePageMeta from '../../hooks/usePageMeta';

// /shop/find-my-lock/photos — the one place the shop asks for photos before a sale, and only
// because the walk-through could not pick a lock ("something else" on the door): a locksmith
// has to choose it. Unlinked from everywhere else and noindex; every other photo ask is a
// step after payment (Hugh, 17 Sep 2026). `?about=` carries the chooser's answers.
const DoorPhotosPage = () => {
  usePageMeta();
  const about = new URLSearchParams(useLocation().search).get('about') || '';
  return (
    <div className="min-h-screen bg-white">
      <PageHero title="This door needs a locksmith's eye" sub="Three photos of the door; we reply with the lock that fits and the fitted price." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Breadcrumbs crumbs={[{ name: 'Home', path: '/' }, { name: 'Shop', path: '/shop' }, { name: 'Find my lock', path: '/shop/find-my-lock' }, { name: 'Send photos' }]} />
        <div className="max-w-3xl rounded-2xl border-2 border-red-200 bg-red-50/40 p-5 sm:p-6" data-testid="door-photos-page">
          <DoorEnquiryForm about={about} />
        </div>
      </div>
    </div>
  );
};

export default DoorPhotosPage;
